import appStyles from "@App/app.module.scss";

/**
 * Locks body scroll using `overflow: clip` instead of `overflow: hidden`.
 *
 * Unlike the standard `lockBody()`, this preserves `position: sticky` behavior
 * on descendant elements. `overflow: clip` prevents scrolling without creating
 * a new scroll container, so sticky children continue to stick at their
 * configured viewport offset.
 *
 * Use this on pages with sticky sidebars (e.g. PropertyPage RightSection)
 * where a modal overlay needs to prevent background scroll.
 *
 * @see unlockBodySticky — removes the lock
 * @see lockBody — standard scroll lock (breaks sticky positioning)
 */
const lockBodySticky = (): void => {
  document?.body?.classList?.add(appStyles.bodyLockedSticky);
  const html = document?.getElementsByTagName("html");
  html?.[0]?.classList.add(appStyles.bodyLockedSticky);
};

export default lockBodySticky;
